var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var defaultProps = {
    color: '#606060',
    onClick: function () { },
};
var CrossCircle = function CrossCircle(props) {
    var color = props.color, onClick = props.onClick;
    return (_jsxs("svg", __assign({ width: "29", height: "29", viewBox: "0 0 29 29", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "cross-circle-svg", onClick: onClick }, { children: [_jsx("rect", { width: "29", height: "29", fill: "none" }), _jsx("circle", { opacity: "0.543816", cx: "14.5", cy: "14.5", r: "14.5", fill: color, fillOpacity: "0.620013" }), _jsx("path", { d: "M9.50818 19.7311L19.7312 9.50815", stroke: "white", strokeWidth: "3", strokeLinecap: "square" }), _jsx("path", { d: "M9.50812 9.50843L19.7311 19.7314", stroke: "white", strokeWidth: "3", strokeLinecap: "square" })] })));
};
CrossCircle.defaultProps = defaultProps;
export default CrossCircle;
